import React, { useState } from 'react';
import '../../containers/Faqs/Faqs.css';

const FAQs = () => {
  const [activeAccordion, setActiveAccordion] = useState({
    section: 'getting-started',
    item: 0
  });
  const toggleAccordion = (section, index) => {
    if (activeAccordion.section === section && activeAccordion.item === index) {
      setActiveAccordion({ section: '', item: null });
    } else {
      setActiveAccordion({ section, item: index });
    }
  };
  const faqData = {
    'getting-started': [
      {
        question: 'Who can use Stelmart?',
        answer: 'Stelmart is open to manufacturers, distributors, wholesalers, traders, and financial institutions in the steel and polymer industries. '
      },
      {
        question: 'How do I sign up?',
        answer: 'Simple! Click on the "Register" button, fill in your business details, and get verified to start buying or selling.'
      },
      {
        question: 'Is there a membership fee?',
        answer: ' No! Signing up and exploring the platform is free. Transaction-based fees may apply for certain services.'
      }
    ],
    'buying-on-stelmart': [
      {
        question: 'How do I find products?',
        answer: 'Browse our extensive catalog, filter products based on your needs, and request quotes directly from verified sellers.'
      },
      {
        question: 'How do negotiations work?',
        answer: 'Buyers and sellers can negotiate terms through our secure messaging system, ensuring a seamless and transparent process.'
      },
      {
        question: 'Is my payment safe?',
        answer: 'Absolutely! We use escrow-backed payments, meaning funds are securely held until the transaction is successfully completed.'
      }
    ],
    'selling-on-stelmart': [
      {
        question: 'How can I list my products?',
        answer: 'After signing up, you can easily upload product details, set prices, and start receiving inquiries from potential buyers.'
      },
      {
        question: 'What happens after I receive an inquiry?',
        answer: ' Respond with a competitive quote, negotiate terms, and finalize the deal—all within our platform.'
      },
      {
        question: 'How do I get paid?',
        answer: 'Payments are securely processed and released once the transaction is completed, eliminating default risks.'
      }
    ],
    'financial-solutions': [
      {
        question: 'Does Stelmart offer financing options?',
        answer: ' Yes! We partner with NBFCs and financial institutions to provide credit solutions, ensuring businesses have the working capital they need.'
      },
      {
        question: 'Can I track my orders?',
        answer: 'Yes! Our platform offers real-time tracking, so you always know the status of your shipments.'
      },
      {
        question: 'What if I face any issues?',
        answer: ' Our dedicated support team is available to assist you. Simply reach out via chat, email, or phone for prompt resolution.'
      }
    ]
  };
  return (
    <div className="faq-page ">
      <section className="banner">
        <div className="overlay">
          {/* <h1>FAQs</h1>
          <p>Find answers to all your questions about using Stelmart platform</p> */}
        </div>
      </section>
      <div className="container font-poppins  custom-container-side custom-container-upper">
        <main className="main-content container custom-inner-space">
          <div className="faq-header ">
            <h1>Everything You Need to Know  </h1>
            <p className='faq-left '>
              Welcome to Stelmart’s FAQ section! Whether you’re a buyer, seller, or just curious about our platform, we’ve got you covered.
            </p>
          </div>
          <section className="faq-section" id="getting-started">
            <h2 >Getting Started</h2>
            <ul className="accordion faq-space">
              {faqData['getting-started'].map((item, index) => (
                <li className="accordion-item" key={`getting-started-${index}`}>
                  <div
                    className={`accordion-header ${activeAccordion.section === 'getting-started' && activeAccordion.item === index ? 'active' : ''}`}
                    onClick={() => toggleAccordion('getting-started', index)}
                  >
                    <h3>{item.question}</h3>
                    <span className="icon">▼</span>
                  </div>
                  <div className={`accordion-content ${activeAccordion.section === 'getting-started' && activeAccordion.item === index ? 'show' : ''}`}>
                    <p>{item.answer}</p>
                  </div>
                </li>
              ))}
            </ul>
          </section>
          <section className="faq-section" id="buying-on-stelmart">
            <h2>Buying on Stelmart</h2>
            <ul className="accordion faq-space">
              {faqData['buying-on-stelmart'].map((item, index) => (
                <li className="accordion-item" key={`buying-on-stelmart-${index}`}>
                  <div
                    className={`accordion-header ${activeAccordion.section === 'buying-on-stelmart' && activeAccordion.item === index ? 'active' : ''}`}
                    onClick={() => toggleAccordion('buying-on-stelmart', index)}
                  >
                    <h3>{item.question}</h3>
                    <span className="icon">▼</span>
                  </div>
                  <div className={`accordion-content ${activeAccordion.section === 'buying-on-stelmart' && activeAccordion.item === index ? 'show' : ''}`}>
                    <p>{item.answer}</p>
                  </div>
                </li>
              ))}
            </ul>
          </section>
          <section className="faq-section" id="selling-on-stelmart">
            <h2>Selling on Stelmart</h2>
            <ul className="accordion faq-space">
              {faqData['selling-on-stelmart'].map((item, index) => (
                <li className="accordion-item" key={`selling-on-stelmart-${index}`}>
                  <div
                    className={`accordion-header ${activeAccordion.section === 'selling-on-stelmart' && activeAccordion.item === index ? 'active' : ''}`}
                    onClick={() => toggleAccordion('selling-on-stelmart', index)}
                  >
                    <h3>{item.question}</h3>
                    <span className="icon">▼</span>
                  </div>
                  <div className={`accordion-content ${activeAccordion.section === 'selling-on-stelmart' && activeAccordion.item === index ? 'show' : ''}`}>
                    <p>{item.answer}</p>
                  </div>
                </li>
              ))}
            </ul>
          </section>
          <section className="faq-section" id="financial-solutions">
            <h2>Financial Solutions & Support</h2>
            <ul className="accordion faq-space">
              {faqData['financial-solutions'].map((item, index) => (
                <li className="accordion-item" key={`financial-solutions-${index}`}>
                  <div
                    className={`accordion-header ${activeAccordion.section === 'financial-solutions' && activeAccordion.item === index ? 'active' : ''}`}
                    onClick={() => toggleAccordion('financial-solutions', index)}
                  >
                    <h3>{item.question}</h3>
                    <span className="icon">▼</span>
                  </div>
                  <div className={`accordion-content ${activeAccordion.section === 'financial-solutions' && activeAccordion.item === index ? 'show' : ''}`}>
                    <p>{item.answer}</p>
                  </div>
                </li>
              ))}
            </ul>
          </section>
          <section className="faq-section" id="end-section">
            <p>Still have questions? Contact us today. Let’s redefine the steel and polymer industry together.</p>
          </section>
        </main>
        <aside className="sidebar">
          <h3>FAQs</h3>
          <ul className="sidebar-menu">
            <li><a href="#getting-started" className={activeAccordion.section === 'getting-started' ? 'active' : ''}>Getting Started</a></li>
            <li><a href="#buying-on-stelmart" className={activeAccordion.section === 'buying-on-stelmart' ? 'active' : ''}>Buying on Stelmart</a></li>
            <li><a href="#selling-on-stelmart" className={activeAccordion.section === 'selling-on-stelmart' ? 'active' : ''}>Selling on Stelmart</a></li>
            <li><a href="#financial-solutions" className={activeAccordion.section === 'financial-solutions' ? 'active' : ''}>Financial Solutions & Support</a></li>
          </ul>
        </aside>
      </div>
    </div>
  );
};
export default FAQs;